import React from 'react';

import {
  ClientSearchFormValues,
  ClientSearchFormViolation,
} from 'types/clientSearchFormTypes';
import { Client } from 'types/clientTypes';
import { createClientSearchFormValues } from 'utils/clientSearchFormUtils';

export const useClientSearchForm = () => {
  const [values, setValues] = React.useState<ClientSearchFormValues>(
    createClientSearchFormValues
  );

  const [violations, setViolations] = React.useState<
    ClientSearchFormViolation[]
  >([]);

  const setTextValue = React.useCallback((nextValue: string) => {
    setValues((prev) => ({ ...prev, text: nextValue }));

    setViolations([]);
  }, []);

  const setClientValue = React.useCallback((nextValue: null | Client) => {
    setValues((prev) => ({ ...prev, client: nextValue }));

    setViolations([]);
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setTextValue,
    setClientValue,
  };
};
